// @ts-nocheck
import { useState } from "react"
import { Link } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"
import { useToast } from "@/components/ui/ToastProvider"

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const { success, error: showError } = useToast()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) return
    setLoading(true)
    try {
      const { error } = await supabaseClient.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin + "/auth/reset-password",
      })
      if (error) { showError("Error", error.message); return }
      success("Email sent!", "Check your inbox for a reset link.")
      setSent(true)
    } catch (e: any) {
      showError("Failed", e.message)
    } finally { setLoading(false) }
  }

  return (
    <div className="auth-wrap" style={{ justifyContent: "center", alignItems: "center" }}>
      <div style={{ width: "100%", maxWidth: 380, padding: "1.5rem" }}>
        <div className="auth-box">
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: "1.5rem" }}>
            <SquidsIcon size={28} /><span className="sq-logo" style={{ fontSize: "1.4rem" }}>SQUIDS</span>
          </div>
          {sent ? (
            <div style={{ textAlign: "center", padding: "1rem 0" }}>
              <p style={{ fontSize: "2rem", marginBottom: ".5rem" }}>📬</p>
              <h2 className="font-outfit font-bold text-lg mb-2">Email sent!</h2>
              <p className="text-sm" style={{ color: "var(--text2)", marginBottom: "1.5rem" }}>
                Check your inbox for a password reset link.
              </p>
              <Link to="/auth/login" className="sq-btn sq-btn-primary" style={{ width: "100%", justifyContent: "center", display: "flex" }}>
                Back to Login
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-outfit font-bold text-xl mb-1">Reset password</h1>
              <p className="text-sm mb-5" style={{ color: "var(--text2)" }}>
                Enter your email and we'll send a reset link.
              </p>
              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: ".75rem" }}>
                <input
                  type="email" value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Email address"
                  className="sq-input" autoFocus required autoComplete="email"
                />
                <button type="submit" disabled={loading || !email} className="sq-btn sq-btn-primary" style={{ width: "100%", padding: ".6rem", justifyContent: "center" }}>
                  {loading ? <Spinner /> : "Send Reset Link"}
                </button>
              </form>
              <div style={{ textAlign: "center", marginTop: "1.25rem" }}>
                <Link to="/auth/login" style={{ fontSize: ".82rem", color: "var(--brand)", fontWeight: 600 }}>← Back to login</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

function SquidsIcon({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <rect width="48" height="48" rx="10" fill="#ff4500" />
      <path d="M15 17.5C15 14.462 17.462 12 20.5 12H29C30.105 12 31 12.895 31 14C31 15.105 30.105 16 29 16H20.5C19.672 16 19 16.672 19 17.5C19 18.328 19.672 19 20.5 19H27.5C30.538 19 33 21.462 33 24.5C33 27.538 30.538 30 27.5 30H19C17.895 30 17 30.895 17 32C17 33.105 17.895 34 19 34H28.5C29.328 34 30 34.672 30 35.5C30 36.328 29.328 37 28.5 37H19C16.239 37 14 34.761 14 32C14 29.239 16.239 27 19 27H27.5C28.328 27 29 26.328 29 25.5C29 24.672 28.328 24 27.5 24H20.5C17.462 24 15 21.538 15 18.5V17.5Z" fill="white" />
    </svg>
  )
}

function Spinner() {
  return (
    <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity=".25" />
      <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}
